var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponicon = function SvgCouponicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.224.848-.072-.072a.63.63 0 0 0-.426-.174h-4.77a1.2 1.2 0 0 0-.852.354L.772 5.288a.6.6 0 0 0 0 .846l5.094 5.094a.6.6 0 0 0 .846 0l4.332-4.332a1.2 1.2 0 0 0 .354-.852v-4.77a.63.63 0 0 0-.174-.426Zm-1.026 5.196L6.292 9.956 2.044 5.708l3.912-3.906h4.242v4.242Zm-1.2-1.842a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgCouponicon;